import { Colors, Services, regExp } from '@sigma-frontend-libs/commons'
import { TaskStates, TaskTypes } from '@sigmasms/shared-types'

import { buttonModes, components, icons, popperPlacements } from '@/utils'

import button from '@/components/button'

function renderActivator(h) {
  return h(
    button,
    {
      props: {
        label: [ this.value.batch, this.value.every ].join(' / '),
        mode: buttonModes.flat,
        icon: icons.speed,
        color: Colors.primary,
        loading: this.loading,
        disabled: this.loading
      },
      slot: 'activator'
    }
  )
}

function renderField(h, field) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy[field],
        label: this.getTranslate(`${Services.tasks}.labels.cycle.${field}`),
        mode: buttonModes.outline,
        disabled: this.loading,
        dense: true,
        details: false,
        mask: regExp.strictPositiveInteger
      },
      on: {
        input: event => {
          this.proxy[field] = event
        }
      }
    }
  )
}
function renderFields(h) {
  return h(
    'div',
    {
      class: `${Services.tasks}-batch-params__fields`
    },
    [
      [ 'batch', 'every' ].map(field => {
        return renderField.call(this, h, field)
      })
    ]
  )
}
function renderUpdateButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: icons.done,
        loading: this.loading,
        disabled: this.loading || !this.proxyIsChanged,
        color: Colors.primary,
        tooltip: this.getTranslate('misc.buttons.update')
      },
      on: {
        click: () => {
          this.updateTask()
        }
      }
    }
  )
}
function renderResetButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: icons.restore,
        disabled: this.loading || this.proxyIsDefault,
        tooltip: this.getTranslate('misc.buttons.reset')
      },
      on: {
        click: () => {
          this.resetProxy()
        }
      }
    }
  )
}
function renderCloseButton(h) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        icon: icons.close,
        disabled: this.loading,
        tooltip: this.getTranslate('misc.buttons.close')
      },
      on: {
        click: () => {
          this.showMenu = false
        }
      }
    }
  )
}
function renderActions(h) {
  return h(
    'div',
    {
      class: `${Services.tasks}-batch-params__actions`
    },
    [
      renderUpdateButton.call(this, h),
      renderResetButton.call(this, h),
      renderCloseButton.call(this, h)
    ]
  )
}
function renderContent(h) {
  return h(
    'div',
    {
      class: `${Services.tasks}-batch-params`
    },
    [
      renderFields.call(this, h),
      renderActions.call(this, h)
    ]
  )
}

export default function(h) {
  if (this.type === TaskTypes['sendings:bulk']) {
    if ([ TaskStates.paused, TaskStates.running, TaskStates.scheduled ].includes(this.state)) {
      if (this.canUpdateTasksAsAdmin) {
        let menuPlacement
        if (!this.viewport.breakpoint.xs) {
          menuPlacement = popperPlacements.left
        } else {
          menuPlacement = popperPlacements.top
        }

        return h(
          components.menu,
          {
            props: {
              value: this.showMenu,
              closeOnClick: false,
              closeOnContentClick: false,
              placement: menuPlacement,
              offsetDistance: 8,
              rounded: true,
              disabled: this.loading
            },
            on: {
              input: event => {
                this.showMenu = event
              }
            }
          },
          [
            renderActivator.call(this, h),
            renderContent.call(this, h)
          ]
        )
      }
    }
  }
}
